import React, { useState } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import Header from "../../../components/molecules/Header";
import { useHistory } from "react-router-dom";
import useStyles from "./style";
import LogoTokoramePoint from "../../../assets/icon/logoTokoramePoint";
import Typography from "@material-ui/core/Typography";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../../components/TabPanel";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Divider from "@material-ui/core/Divider";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from "@material-ui/core/IconButton";



function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function About({ value }) {
  const { inpointAbout } = useData();
  return (
    <TabPanel value={value} index="about">
      <div>
        <Typography variant="body2">{inpointAbout.description}</Typography>
      </div>
    </TabPanel>
  );
}

function HowTo({ value }) {
  const { inpointHow } = useData();
  const classes = useStyles();

  console.log(inpointHow);

  return (
    <TabPanel value={value} index="how-to-get">
      <List>
        {inpointHow?.earn_points?.length > 0 ? (
          inpointHow?.earn_points?.map((item) => (
            <>
              <ListItem button>
                <ListItemIcon>
                  <AttachMoneyIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography className={classes.liquidListPrimary}>
                      {item?.title}
                    </Typography>
                  }
                  secondary={
                    <div>
                      <Typography className={classes.liquidSecondList}>
                        {item?.description ?? "-"}
                      </Typography>
                    </div>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge="end" size="small">
                    <Typography className={classes.liquidListThird}>
                    {item?.coins ?? "-"} Coin
                    </Typography>
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider />
            </>
          ))
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              marginTop: "2.5%",
            }}
          >
            <Typography className={classes.liquidPrimary}>
              Tidak Ada Data
            </Typography>
          </div>
        )}
      </List>
    </TabPanel>
  );
}

function PointInfo() {
  const history = useHistory();
  const classes = useStyles();

  const [tabValue, setTabValue] = useState("about");

  const [tabs, setTabs] = useState([
    {
      label: "Apa itu Tokorame Coin",
      value: "about",
    },
    {
      label: "Cara Mendapatkan Coin",
      value: "how-to-get",
    },
  ]);

  const handleChange = (event, value) => {
    setTabValue(value);
  };

  return (
    <>
      {" "}
      <Header
        type="with-title"
        title="Info Tokorame Coin"
        onClick={() => history.push("/tokoramecoin")}
      />
      <div className={classes.wrap}>
        <div style={{ textAlign: "center", padding: "20px" }}>
          <div>
            <LogoTokoramePoint />
          </div>
          <div>
            <Typography variant="h6">Tokorame Coin</Typography>
            <Typography variant="caption" style={{ color: "#C4C4C4" }}>
              Tokorame
            </Typography>
          </div>
        </div>
        <div>
          <div>
            <Tabs
              variant="fullWidth"
              aria-label="full width tabs example"
              textColor="primary"
              value={tabValue || "about"}
              onChange={handleChange}
              TabIndicatorProps={{
                style: {
                  background: "rgb(86,117,211)",
                  background:
                    "linear-gradient(90deg, rgba(86,117,211,1) 70%, rgba(249,163,61,1) 70%, rgba(249,163,61,1) 90%, rgba(244,84,141,1) 90%)",
                },
              }}
              size="small"
            >
              {tabs.map((tab) => (
                <Tab
                  className={classes.tab}
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  {...a11yProps(tab.value)}
                />
              ))}
            </Tabs>
            <About value={tabValue} />
            <HowTo value={tabValue} />
          </div>
        </div>
      </div>
    </>
  );
}

export default PointInfo;
